import { createSlice } from '@reduxjs/toolkit';
import { BaseApiState } from '../../api/axiosConfig';
import { ExternalUrls } from '../../api/exernalUrlApi';
import { handlePending, handleReject } from '../../utils/redux';
import { getExternalUrls } from './thunks';

interface ExternalUrlsState extends BaseApiState {
  externalUrls: ExternalUrls | null;
}
const initialState: ExternalUrlsState = {
  externalUrls: null,
  succeeded: false,
  loading: false,
  error: false,
  errorMessage: '',
  errorDetails: {},
};

export const externalUrlsSlice = createSlice({
  name: 'externalUrls',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getExternalUrls.pending, handlePending)
      .addCase(getExternalUrls.fulfilled, (state, action) => {
        state.externalUrls = action.payload ?? {};
        state.succeeded = true;
        state.loading = false;
      })
      .addCase(getExternalUrls.rejected, handleReject);
  },
});

export const externalUrlsReducer = externalUrlsSlice.reducer;
